import UserAvatar from "../UserAvatar"
import styles from "./styles.module.scss"
import NavigatorAvatar from "../NavigatorAvatar"
import classNames from "classnames"

export type TypingUser = { avatar: string; firstName: string; lastName: string; userId: string }

export const TypingIndicator = ({
  isNavigatorLoading,
  typingUserList,
}: {
  isNavigatorLoading: boolean
  typingUserList: TypingUser[]
}) => {
  return (
    <div className={styles.typingIndicator}>
      <div className={styles.indicatorHeader}>
        {isNavigatorLoading ? (
          <div className={styles.avatarWrapper}>
            <NavigatorAvatar />
          </div>
        ) : (
          <div className={styles.userAvatars}>
            {typingUserList.slice(0, 3).map((user, index) => (
              <div
                key={user.userId}
                className={styles.avatarWrapper}
                style={{ left: `${index * 16}px` }}
              >
                <UserAvatar
                  size="sm"
                  fontSize="14px"
                  avatar={user.avatar}
                  userId={user.userId}
                  isPrimary={false}
                  nameInitals={`${user.firstName[0]}${user.lastName[0]}`}
                />
              </div>
            ))}
          </div>
        )}
      </div>
      <div className={classNames(styles.dotsContainer, styles.animate)}>
        <span className={styles.dot}>.</span>
        <span className={styles.dot}>.</span>
        <span className={styles.dot}>.</span>
      </div>
    </div>
  )
}
